<h2 mat-dialog-title class="sd-title">{{ '@issueSuppressTitle' | translate }}</h2>

<mat-dialog-content>
  <p class="sd-body">{{ '@issueSuppressHelp' | translate }}</p>

  <label class="sd-label" for="sd-days">{{ '@issueSuppressForDays' | translate }}</label>
  <input class="fhd-filter-input sd-days" id="sd-days" type="number" inputmode="numeric"
         data-e2e="suppress-days" autocomplete="off"
         [min]="minDays" [max]="maxDays" step="1"
         [(ngModel)]="days"
         (keyup.enter)="suppress()" />
  <!-- Says the bound before the reader meets it, rather than only refusing afterwards. -->
  <p class="sd-range" [class.bad]="!valid">
    {{ '@issueSuppressRange' | translate: { min: minDays, max: maxDays } }}
  </p>
</mat-dialog-content>

<div mat-dialog-actions class="sd-actions">
  <button type="button" mat-raised-button color="primary" cdkFocusInitial
          data-e2e="suppress-confirm" [disabled]="!valid" (click)="suppress()">
    {{ '@issueSuppressConfirm' | translate }}
  </button>
  <button type="button" mat-button class="sd-decline" data-e2e="suppress-decline"
          (click)="decline()">
    {{ '@issueSuppressDecline' | translate }}
  </button>
  <button type="button" mat-button data-e2e="suppress-cancel" (click)="cancel()">
    {{ '@cancel' | translate }}
  </button>
</div>
